







































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { DxSwitch } from 'devextreme-vue/switch';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';

@Component({
  components: {
    DxPopup,
    DxToolbarItem,
    DxSwitch,
  },
})
export default class UserSettingDialog extends Vue {
    public mesurementstatsval: any = false;
    public projectstatsval: any = false;
    public quotationstatsval: any = false;
    public invoicestatsval: any = false;

    public mesurementStatsStyle: any = 'display:none';
    public projectStatsStyle: any = 'display:none';
    public quotationStatsStyle: any = 'display:none';
    public invoiceStatsStyle: any = 'display:none';

    public langNLBtnStyle: any = 'btn btn-primary';
    public langENBtnStyle: any = 'btn btn-primary';

    public show: boolean = false;

    public hideDialog() {
        this.$emit('hideDialog');
        localStorage.setItem('usersettingsdialog', 'false');
        window.location.reload();
    }

    public mounted() {
        const lang = localStorage.getItem('lang');
        if (lang === 'en') {
            this.langENBtnStyle = 'btn btn-danger';
            this.langNLBtnStyle = 'btn btn-primary';
        } else {
            this.langNLBtnStyle = 'btn btn-danger';
            this.langENBtnStyle = 'btn btn-primary';
        }

        this.mesurementstatsval = (localStorage.getItem('mesurementstatsval') === 'true') ? true : false;
        this.projectstatsval = (localStorage.getItem('projectstatsval') === 'true') ? true : false;
        this.quotationstatsval = (localStorage.getItem('quotationstatsval') === 'true') ? true : false;
        this.invoicestatsval = (localStorage.getItem('invoicestatsval') === 'true') ? true : false;

        this.mesurementStatsStyle = localStorage.getItem('mesurementStatsStyle');
        this.projectStatsStyle = localStorage.getItem('projectStatsStyle');
        this.quotationStatsStyle = localStorage.getItem('quotationStatsStyle');
        this.invoiceStatsStyle = localStorage.getItem('invoiceStatsStyle');

    }

    public switchMesurement(e: any) {
      localStorage.setItem('mesurementstatsval', e.value);
      this.mesurementstatsval = (localStorage.getItem('mesurementstatsval') === 'true') ? true : false;

      const mesurementStatsStyle = (this.mesurementstatsval === true) ? 'display:block' : 'display:none';
      localStorage.setItem('mesurementStatsStyle', mesurementStatsStyle);
    }

    public switchProject(e: any) {
      localStorage.setItem('projectstatsval', e.value);
      this.projectstatsval = (localStorage.getItem('projectstatsval') === 'true') ? true : false;

      const projectStatsStyle = (this.projectstatsval === true) ? 'display:block' : 'display:none';
      localStorage.setItem('projectStatsStyle', projectStatsStyle);
    }

    public switchQuotation(e: any) {
      localStorage.setItem('quotationstatsval', e.value);
      this.quotationstatsval = (localStorage.getItem('quotationstatsval') === 'true') ? true : false;

      const quotationStatsStyle = (this.quotationstatsval === true) ? 'display:block' : 'display:none';
      localStorage.setItem('quotationStatsStyle', quotationStatsStyle);
    }

    public switchInvoice(e: any) {
      localStorage.setItem('invoicestatsval', e.value);
      this.invoicestatsval = (localStorage.getItem('invoicestatsval') === 'true') ? true : false;

      const invoiceStatsStyle = (this.invoicestatsval === true) ? 'display:block' : 'display:none';
      localStorage.setItem('invoiceStatsStyle', invoiceStatsStyle);
    }

    public setLang(val: string) {
      this.$i18n.locale = val;
      localStorage.setItem('lang', val);

      if (val === 'en') {
          this.langENBtnStyle = 'btn btn-danger';
          this.langNLBtnStyle = 'btn btn-primary';
      } else {
          this.langNLBtnStyle = 'btn btn-danger';
          this.langENBtnStyle = 'btn btn-primary';
      }

    }
}
